'use strict';

angular.module('internal.licenses')
    .controller('InternalLicensePackages', ['$scope', function ($scope) {
        $scope.resetLicense();
        $scope.columns = [
            {
                label: 'Name',
                field: 'name',
                link: {
                    state: 'internal.licensing.license.package',
                    params: [
                        {
                            name: 'packageID',
                            field: 'id'
                        },
                        {
                            name: 'package',
                            field: ''
                        }
                    ]
                }
            }
        ]
    }])
;